/** Shared social channel defaults and app-first open helpers. */

export const DEFAULT_SOCIAL_URLS = {
  youtube: 'https://www.youtube.com/@Radhekrishnabapuofficial',
  facebook: 'https://www.facebook.com/radhekrishnashastri.bapu',
  instagram: 'https://www.instagram.com/radhekrishnabapu_official',
};

const ANDROID_PACKAGES = {
  youtube: 'com.google.android.youtube',
  facebook: 'com.facebook.katana',
  instagram: 'com.instagram.android',
};

function getUserAgent() {
  return typeof navigator !== 'undefined' ? navigator.userAgent || '' : '';
}

export function isAndroid() {
  return /Android/i.test(getUserAgent());
}

export function isIOS() {
  return /iPhone|iPad|iPod/i.test(getUserAgent());
}

export function isMobileDevice() {
  if (typeof window === 'undefined') return false;
  if (isAndroid() || isIOS()) return true;
  if (typeof window.matchMedia === 'function') {
    try {
      if (window.matchMedia('(pointer: coarse)').matches) return true;
    } catch {
      /* ignore */
    }
  }
  return /Mobile|Android|iPhone|iPad|iPod/i.test(getUserAgent());
}

/** @returns {'youtube'|'facebook'|'instagram'|null} */
export function detectSocialPlatform(url) {
  if (!url) return null;
  try {
    const host = new URL(String(url).trim()).hostname.replace(/^www\./, '').toLowerCase();
    if (host === 'youtu.be' || host.endsWith('youtube.com') || host.endsWith('youtube-nocookie.com')) {
      return 'youtube';
    }
    if (host === 'facebook.com' || host.endsWith('.facebook.com') || host === 'fb.com' || host === 'fb.watch') {
      return 'facebook';
    }
    if (host === 'instagram.com' || host.endsWith('.instagram.com')) {
      return 'instagram';
    }
  } catch {
    /* ignore */
  }
  return null;
}

/**
 * Build an Android Intent URL that prefers the native app, with https fallback.
 * @param {string} httpsUrl
 * @param {'youtube'|'facebook'|'instagram'} platform
 */
export function buildAndroidIntentUrl(httpsUrl, platform) {
  const pkg = ANDROID_PACKAGES[platform];
  if (!pkg || !httpsUrl) return httpsUrl;

  let parsed;
  try {
    parsed = new URL(httpsUrl);
  } catch {
    return httpsUrl;
  }

  const scheme = parsed.protocol.replace(':', '') || 'https';
  const hostAndPath = `${parsed.host}${parsed.pathname}${parsed.search}${parsed.hash}`;
  const fallback = encodeURIComponent(httpsUrl);

  return `intent://${hostAndPath}#Intent;scheme=${scheme};package=${pkg};S.browser_fallback_url=${fallback};end`;
}

/**
 * Open a social URL: desktop new tab; Android Intent (app or browser);
 * iOS same-tab https for Universal Links.
 * @param {string} httpsUrl
 * @returns {boolean} whether navigation was attempted
 */
export function openSocialUrl(httpsUrl) {
  const url = httpsUrl != null ? String(httpsUrl).trim() : '';
  if (!url || typeof window === 'undefined') return false;

  const platform = detectSocialPlatform(url);

  if (isAndroid() && platform) {
    window.location.href = buildAndroidIntentUrl(url, platform);
    return true;
  }

  if (isIOS()) {
    window.location.assign(url);
    return true;
  }

  window.open(url, '_blank', 'noopener,noreferrer');
  return true;
}
